/**
 * @generated SignedSource<<f2f5ea60618e877ff5a2993b524f9bee>>
 * @relayHash 09692307ef9d5449b9314731266a9a48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a5025a7606e1b419cfaa2240d0c09cec5ee59a77b2ce5721394d5cfcc054563a

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type notificationLogsPageWithFiltersQuery$variables = {
  cloudId: string;
  notificationActionType?: string | null | undefined;
  notificationType?: string | null | undefined;
  projectId?: AGG$Long | null | undefined;
};
export type notificationLogsPageWithFiltersQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"notificationLogsPage_spaAppsServicedeskNotificationLogs_NotificationLogsWithFilters">;
};
export type notificationLogsPageWithFiltersQuery = {
  response: notificationLogsPageWithFiltersQuery$data;
  variables: notificationLogsPageWithFiltersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationActionType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "notificationLogsPageWithFiltersQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "notificationLogsPage_spaAppsServicedeskNotificationLogs_NotificationLogsWithFilters"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "notificationLogsPageWithFiltersQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "AquaOutgoingEmailLogsQueryApi",
        "kind": "LinkedField",
        "name": "aquaOutgoingEmailLogs",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "notificationActionType",
                "variableName": "notificationActionType"
              },
              {
                "kind": "Variable",
                "name": "notificationType",
                "variableName": "notificationType"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "LinkedField",
            "name": "GetNotificationLogs",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "AquaOutgoingEmailLogConnection",
                    "kind": "LinkedField",
                    "name": "logs",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AquaOutgoingEmailLogItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AquaOutgoingEmailLogItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "notificationActionType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "actionTimestamp"
                              },
                              {
                                "concreteType": "AquaNotificationDetails",
                                "kind": "LinkedField",
                                "name": "notificationDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "errorKey"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "mailboxMessage"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "recipient",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "email"
                                      }
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      }
                                    ],
                                    "type": "CustomerUser"
                                  },
                                  (v6/*: any*/)
                                ]
                              },
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "startCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasPreviousPage"
                          }
                        ]
                      }
                    ],
                    "storageKey": "logs(first:20)"
                  },
                  {
                    "args": (v5/*: any*/),
                    "handle": "connection",
                    "key": "aquaOutgoingEmail__logs",
                    "kind": "LinkedHandle",
                    "name": "logs"
                  }
                ],
                "type": "AquaOutgoingEmailLog"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a5025a7606e1b419cfaa2240d0c09cec5ee59a77b2ce5721394d5cfcc054563a",
    "metadata": {},
    "name": "notificationLogsPageWithFiltersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c77cb7f044c5201afd97b3bb7a707bd0";

export default node;
